<template>
    <tr class="applicant-list">
      <td style="min-width: 30px!important;">
        <input
                type="checkbox"
                v-bind:value="applicantData.id"
                @change="checkUncheckJobseeker(applicantData.id)"
                :checked="isChecked" style="margin-top:4px;"
        />
      </td>
      <td
        style="padding-left:0px !important; min-width: 40px !important; max-width: 50px !important;"
        @click="showProfile"
      >{{rowNumber}}</td>
      <template>
        <td
          class="td-date"
          @click="showProfile"
        >
          {{ scoutedDate }}
        </td>

        <td
          class="text-left"
          style="min-width: 150px !important; max-width: 150px !important;"
          @click="showProfile"
        >
          {{ applicantData.scoutedJobTitle }}
        </td>

        <td
          class="text-left"
          style="min-width: 200px !important; max-width: 200px !important;"
          @click="showProfile"
        >
          <div class="td-container d-flex flex-column">
            <span
              class="client-name"
              style="cursor: none;font-weight: bold;"
            >
              {{applicantData.last_name}} {{applicantData.name}}
            </span>
            <span>{{applicantData.age}} / {{employment.lastYearIncome}} 万円</span>
             <span v-if="employment.lastCompany">
              {{ employment.lastCompany }}
            </span>
             <span v-if="applicantData.education && applicantData.education.instituteName">
              {{ applicantData.education.instituteName }}
            </span>
          </div>
        </td>
  
        <td
          class="text-right"
          style="min-width: 100px !important; max-width: 100px !important;"
        >
          <div class="d-flex justify-content-center note-btn-grp">
           <Favorite
            :favorite="applicantData.isFavorite"
            @click.native="toggleFavorite(applicantData)"
            :toggledisabled="loading"
          />
           <span class="ms-2"></span>
           <Memo v-bind:key="applicantData.id + applicantData.memo" :applicant="applicantData"/>
           </div>
        </td> 
  
        <td class="text-center status-cell">
          <StatusDropDown
            :applicant="applicantData"
            :isReviewer="isReviewer"
            @hidden="$emit('hidden')"
            @shown="$emit('shown')"
            @statusChanged="statusChanged"
            :class="colorClass"
            :toggledisabledstatus="loading"
            :fromList="true"
          />
        </td>

        <td class="text-center" @click="showProfile">
          <div class="d-flex align-items-center justify-content-center">
             <div v-if="applicantData.hasContact" class="scout-indicator-circle"></div>
          </div>
        </td>

        <td class="text-center" @click="showProfile">
          <span v-if="applicantData.latestContact">
            {{ formatDate(applicantData.latestContact.sent_date) }}
          </span>
        </td>

        <td class="text-left" style="min-width: 180px !important;" @click="showProfile">
          <div
            v-if="latestContactJobTitle"
            class="job-title-truncate"
            :title="latestContactJobTitle"
          >
            {{ latestContactJobTitle }}
          </div>
        </td>
      </template>
      <ProfileModal
        v-if="showProfileModal"
        :applicantId="applicantData.id"
        :applicantIndex="applicantIndex"
        :isFavorite="applicantData.isFavorite"
        :isInterview="applicantData.isInterview"
        :applicantdata="applicantData"
        :showProfileModal="showProfileModal"
        :isPreview="isPreview"
        :isPendingReview="false"
        v-on:hideModal="hideProfile"
      />
      <ReviewListPopup 
        ref="reviewListPopup" 
        :applicant="applicantData"
        :showReviewListModal="showReviewListModal"
        @hideModal="hideReviewList"
      />

    </tr>
  </template>
  
  <script>
  import Favorite from '@/components/dashboard/applicants/Favorite.vue';
  import Memo from '@/components/dashboard/applicants/Memo.vue';
  import ProfileModal from '@/components/dashboard/applicants/profile/ProfileModal.vue';
  import StatusDropDown from '@/components/dashboard/StatusDropDown.vue';
  import ReviewListPopup from '@/components/dashboard/ReviewListPopup.vue';

  import Api from '@/config/api';
  import ApiService from '@/service/apiService';
  import moment from 'moment';
  import { mapGetters, mapState, mapMutations } from 'vuex';
  
  export default {
    name: 'ScoutApplicantsRow',
    components: {
      Memo,
      Favorite,
      StatusDropDown,
      ProfileModal,
      ReviewListPopup,
    },
    props: [
      'applicant',
      'applicantIndex',
      'rowNumber',
      // 'isChecked',
      'isPreview'
    ],
    data() {
      return {
        applicantData: this.applicant,
        showProfileModal: false,
        loading: false,
        showReviewListModal: false,
      };
    },
    computed: {
      ...mapGetters({
        getMenus: 'getMenus',
        isReviewer: 'isCreateReviewUser',
        isAdmin: 'currentUserIsAdmin',
        statusColorMap: 'getStatusColorMap'
      }),
      ...mapState({
        jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      }),
      isChecked() {
        return this.jobseekerIds.includes(this.applicant.id)
      },
      firstMarkedJob() {
          if (this.applicantData.markedJobseekers && this.applicantData.markedJobseekers.length > 0) {
              return this.applicantData.markedJobseekers[0];
          }
          return null;
      },
      latestContactJobTitle() {
        const contact = this.applicantData.latestContact;
        if (!contact) return null;

        if (contact.jd_snapshot && contact.jd_snapshot.job_title) {
          return contact.jd_snapshot.job_title;
        }
        return null;
      },
      scoutedDate() {
          if (!this.applicantData.scoutedDate) return '';
          return moment(this.applicantData.scoutedDate)
          .format('YYYY-MM-DD');    
      },

      employment() {
        return this.applicantData.employment;
      },

      colorClass() {
        const status = this.applicantData.new_status || this.applicantData.status;
        if (status && this.statusColorMap[status]) {
          return `status-${status}`;
        }
        return '';
      },
    },
  
    methods: {
      ...mapMutations({
        mutateApplicantsAfterFav: 'mutateApplicantsAfterFav',
        mutateApplicantsAfterInterview: 'mutateApplicantsAfterInterview',
        checkUncheckJobseeker: 'checkUncheckJobseeker',
        setReloadApplicants: 'setReloadApplicants',
        setScoutedJd: 'setScoutedJd'
      }),
      showProfile() {
        this.showProfileModal = true;
      },
      // jobTitle(job) {
      //   let jobTitle = job.jobDetails.job_title;
      //   return jobTitle.length > 15 ? jobTitle.substring(0, 15) + '...' : jobTitle;
      // },
      jdTitle(jd){
        return jd.jobDescriptionTitle;
      },
      //remove scout
      async toggleScout() {
        try {
          await ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
            status: '未確認'
          });
          this.setReloadApplicants(true);
        } catch (error) {
          console.log(error);
          this.parseErrorResponse(error.response);
        }
      },
      requestJudgement() { 
        this.showReviewListModal = true;
      },
      hideReviewList() {
        this.showReviewListModal = false;
      },
      getHighlightedContent(paths, originalText) {
        if (!this.applicantData.highlights || !this.applicantData.highlights.length) {
          return originalText;
        }
  
        // Special handling for name fields
        if (paths.includes('last_name') || paths.includes('full_name')) {
          let highlightedText = originalText;
  
          const nameHighlights = this.applicantData.highlights.filter(h => 
            paths.includes(h.path) && h.texts && h.texts.length
          );
  
          for (let highlight of nameHighlights) {
            // Sort hit texts by length (longest first) to handle overlapping matches
            const hitTexts = highlight.texts
              .filter(t => t.type === 'hit')
              .sort((a, b) => b.value.length - a.value.length);
  
            // Process each hit text separately
            for (let hitText of hitTexts) {
              const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
              highlightedText = highlightedText.replace(
                searchRegex, 
                match => `<span class="highlight-hit">${match}</span>`
              );
            }
          }
  
          return highlightedText;
        }
  
        // Regular handling for other fields
        const highlights = this.applicantData.highlights.filter(h => paths.includes(h.path));
        if (highlights.length === 0) {
          return originalText;
        }
  
        let highlightedText = originalText;
  
        for (let highlight of highlights) {
          // Sort hit texts by length (longest first) to handle overlapping matches
          const hitTexts = highlight.texts
            .filter(t => t.type === 'hit')
            .sort((a, b) => b.value.length - a.value.length);
  
          // Process each hit text separately
          for (let hitText of hitTexts) {
            const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
            highlightedText = highlightedText.replace(
              searchRegex, 
              match => `<span class="highlight-hit">${match}</span>`
            );
          }
        }
  
        return highlightedText;
      },
      escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },
      formatDate(date) {
        if (!date) return '';
        return moment(date).format('YYYY-MM-DD');
      },

      toggleFavorite(applicant) {      
        this.loading = true;
        const method = applicant.isFavorite ? 'delete' : 'put';
        ApiService[method](Api.endpoints.FAVORITE(applicant.id))
          .then(({ data }) => {
            // this.applicantData = data.data;
            this.mutateApplicantsAfterFav(data.data);
          })
          .catch(({ response }) => this.parseErrorResponse(response))
          .then(() => {
            this.loading = false;
          });
      },
  

      hideProfile() {
        this.showProfileModal = false;
      },
      statusChanged(data) {
        if (data.new_status !== undefined && data.new_status !== null) {
          this.applicantData.new_status = data.new_status;
        }
        if (data.status !== undefined && data.status !== null) {
          this.applicantData.status = data.status;
        }
        this.setReloadApplicants(true);
      },
    },
    watch: {
      'applicant': {
        handler(newApplicant) {
          if (!newApplicant) return;
          // Store often replaces the row object (Vue.set + spread). Prop is a new reference
          // while applicantData still pointed at the old object — sync the whole row.
          if (this.applicantData !== newApplicant) {
            this.applicantData = newApplicant;
            return;
          }
          const fieldsToUpdate = {
            highlights: newApplicant.highlights,
            last_name: newApplicant.last_name,
            name: newApplicant.name,
            education: newApplicant.education,
            employment: newApplicant.employment,
            memo: newApplicant.memo,
            hasContact: newApplicant.hasContact,
            latestContact: newApplicant.latestContact,
          };
          Object.assign(this.applicantData, fieldsToUpdate);
        },
        deep: false,
      },
      'applicant.status': function () {
        this.applicantData.status = this.applicant.status;
      },
      'applicant.isFavorite': function () {
        this.applicantData.isFavorite = this.applicant.isFavorite;
      },
      'applicant.isInterview': function () {
        this.applicantData.isInterview = this.applicant.isInterview;
      },
      'applicant.hasContact': function () {
        this.applicantData.hasContact = this.applicant.hasContact;
      },
      'applicant.latestContact': {
        handler() {
          this.applicantData.latestContact = this.applicant.latestContact;
        },
        deep: true,
      },
  
    },
  };
  </script>
  
  <style scoped>
  .scout-type {
    width: 120px;
    display: block;
    background: #787878;
    text-align: center;
    /* padding: 10px; */
    height: 32px;
    padding: 5px;
    color: white;
    border-radius: 3px;
  }
  .scouted-jobs {
    /* font-size: 12px; */
    color: #036AC9;
  }
  .note-btn-grp button {
    width: 20px;
  }
  
  .scout-indicator-circle {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: #009D9E;
      border: 1px solid #009D9E;
  }
  
  .memo-container {
      position: relative;
  }

  .job-title-truncate {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
  }

  .expand-link {
    color: #036ac9;
    cursor: pointer;
    font-size: 12px;
    display: block;
    text-align: right;
  }
  </style>
<style>
  .applicant-list {
    border: 2px solid transparent;
    border-left: solid 2px transparent;
    border-right: solid 2px transparent;
  }
  .applicant-list td {
    padding: 5px 7px !important;
  }
  
  .applicant-list:hover {
    /*border-right: solid 2px #0e0e0e6b;*/
    /*border-left: solid 2px #0e0e0e6b;*/
    /*box-shadow:rgba(50, 52, 93, 0) 1px 0px 20px 4px inset, rgb(0 0 0 / 10%) 0px 0px 20px 0px inset;*/
  
    /*-webkit-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
    /*-moz-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
    /*box-shadow: */
    box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
    z-index: 1;
    /*background-color: #f0f5f7!important;*/
  
    border: 2px solid #036d6c;
    /*background-color: #F0F8FD!important;*/
  
  }

  
  .wrapword {
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* css-3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
    word-break: break-all;
    white-space: normal;
  }
  
  .block-with-text {
    /* hide text if it more than N lines  */
    overflow: hidden;
    /* for set '...' in absolute position */
    position: relative; 
    /* use this value to count block height */
    line-height: 1.2em;
    /* max-height = line-height (1.2) * lines max number (3) */
    max-height: 3.6em; 
    /* fix problem when last visible word doesn't adjoin right side  */
    text-align: justify;  
    /* place for '...' */
    margin-right: -1em;
    padding-right: 1em;
  }
  .text-center {
    min-width: 50px !important;
  }
  .text-left {
    text-align: left !important;
  }
  
  .applicant-list >td:hover {
    /*font-weight:600!important;*/
    /*text-decoration: underline;*/
    color:#1e6d6b!important;
  }
  .note-btn-grp >.btn-heart i:hover{
    color:#aba2a2!important;
  }
  .fa-sticky-note:hover{
    color:#aba2a2!important;
  }
  .client-listing-detail table td:first-child {
    min-width:25px!important;
  }
  .client-listing-detail table td:last-child {
    min-width:25px!important;
  }
  
  </style>
  